import Api from './Api'
import {store} from '../store/index'

function getOrgId() {
  return store.getters['user/getOrgContext'] || store.getters['user/getOrgId']
}

export default {
  async getAppConfigs() {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/appconfigs')
  },
  async updateAppConfig(appConfig) {
    return new Api().put('/admin/api/v1/orgs/' + getOrgId() + '/appconfigs' , appConfig)
  }
}